import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["expandable", "toggle"];

  toggle() {
    this.expandableTarget.classList.toggle("hidden");
    const isExpanded = !this.expandableTarget.classList.contains("hidden");
    this.toggleTarget?.setAttribute("aria-expanded", isExpanded);
    this.element.classList.toggle("workflow-execution-list-row--expanded", isExpanded);
  }
}
